import { render, staticRenderFns } from "./phoneLogin.vue?vue&type=template&id=76503a84&scoped=true"
import script from "./phoneLogin.vue?vue&type=script&lang=ts"
export * from "./phoneLogin.vue?vue&type=script&lang=ts"
import style0 from "./phoneLogin.vue?vue&type=style&index=0&id=76503a84&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76503a84",
  null
  
)

export default component.exports